<!-- 选择状态 -->
<template>
  <el-form-item :label="label">
    <el-select v-model="studentStatus" placeholder="请选择" collapse-tags-tooltip fit-input-width :collapse-tags="true" :max-collapse-tags="1"
     multiple clearable>
        <el-option :label="item.name" :key="item.id" :value="item.id" v-for="item in stuStaList"></el-option>
      </el-select>
  </el-form-item>
</template>

<script>
import { inject, computed } from 'vue';

export default {
  kind: 'yq-学员新状态选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number, Object],
      default: () => ([]),
    },
    config: {
      type: Object,
      default() {
        return {
          multiple: true,
          placeholder: '请选择',
        };
      },
    },
    label: {
      type: String,
      default: '学员状态：',
    },
  },
  setup(props) {
    const store = inject('store');
    const useQuery = inject('useQuery');
    const stuStaList = computed(() => {
      const arr = [];
      Object.keys(store.studentsStatus.value).map((prop) => {
        if ([0, 1, 6, 7, 99].includes(+prop)) {
          arr.push({
            id: +prop,
            name: store.studentsStatus.value[prop],
          });
        }
        return prop;
      });
      return arr;
    });
    const studentStatus = useQuery('statusList', props.value);
    return {
      studentStatus,
      stuStaList,
    };
  },
};
</script>
